import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import IconLink from 'components/Shared/IconLink/Index'

const CloneLink = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <IconLink
      onClick={onClick}
      iconName='icon-copy'
      text={t('ticketPage.cloneTicketLink')}
    />
  )
}

CloneLink.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default CloneLink
